import PosService from "@/services/PosService";
import Pos_Fnb_Service from '@/services/Pos_Fnb_Service';
import vue from "vue";
const state = {
    posFooterMenus: [],
    posFnbFooterMenus: [],
}

const mutations = {
    SET_POS_MENUS: (state, payload) => {
        state.posFooterMenus = payload || [];
    },
    SET_FNB_POS_MENUS: (state, payload) => {
        state.posFnbFooterMenus = payload || [];
    }
}

const actions = {
    setPosFooterMenus({ commit }, payload) {
        PosService.GetPosFooterMenus()
            .then((response) => {
                const { data } = response;
                if (data.status && data.Records.length > 0) {
                    commit('SET_POS_MENUS', data.Records)
                } else {
                    vue.toasted.show(data.message || "Please try later");
                }
            }).catch((err) => {
                vue.toasted.show(err.message || "Please try later");
            });
    },
    setFnbPosFooterMenus({ commit }, payload) {
        Pos_Fnb_Service.GetPosFnbFooterMenus()
            .then((response) => {
                const { data } = response;
                if (data.status && data.Records.length > 0) {
                    commit('SET_FNB_POS_MENUS', data.Records)
                } else {
                    vue.toasted.show(data.message || "Please try later");
                }
            }).catch((err) => {
                vue.toasted.show(err.message || "Please try later");
            });
    },
}

const getters = {
    getPosFooterMenus: state => state.posFooterMenus,
    getPosFnbFooterMenus: state => state.posFnbFooterMenus
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/PosMenus.js